import { render, staticRenderFns } from "./KeywordForm.vue?vue&type=template&id=78d5f5bf&scoped=true&"
import script from "./KeywordForm.vue?vue&type=script&lang=js&"
export * from "./KeywordForm.vue?vue&type=script&lang=js&"
import style0 from "./KeywordForm.vue?vue&type=style&index=0&id=78d5f5bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5f5bf",
  null
  
)

export default component.exports